<div>
   <img [src]="mtsLogo" alt="MedTracS" />
</div>
<div class="form-column">
   <h1>The site is currently under maintenance.</h1>
   <h1>Please come back later.</h1>
   <lib-icon [content]="icons.cogs"></lib-icon>
</div>